import { IState } from './types';

export const state: IState = {
  isMobile: false,
  params: null,
  currentService: 'create_background_for_image',
  servicesList: ['create_background_for_image'],
};
